export const createCollection = (photo) => {
    return {
        original: `${photo}`,
        thumbnail: `${photo}`
    };
};
